module.exports = __webpack_public_path__ + "static/media/29DUNON12.2d84f5bc.jpg";